import { MentionWithProfileLink } from "@circle-react-uikit/TipTap/Extensions/CustomExtensions/Mentions/MentionsDisplay/MentionWithProfileLink";
import type { Mention } from "@circle-react-uikit/TipTap/Extensions/CustomExtensions/Mentions/MentionsDisplay/types";

interface StaticMentionProps {
  mention: Mention;
}

export const StaticMention = ({ mention }: StaticMentionProps) => (
  <MentionWithProfileLink mention={mention} isChat />
);
